/* NO販売店情報(一覧)検索フォーム */
import React from 'react';
import { useToggle } from '../hooks/ToggleHooks';
import { Collapse, Row } from 'react-bootstrap';
import SearchInput from '../molecules/SearchInput';
import SearchDataList from '../molecules/SearchDataList';
var NoStoreSearchForm = function (_a) {
    var search_params = _a.search_params, search_option = _a.search_option, handleClickSearch = _a.handleClickSearch, handleChangeSearchParams = _a.handleChangeSearchParams, handleClickCreateButton = _a.handleClickCreateButton;
    // 検索条件表示フラグ
    var _b = useToggle(true), show = _b[0], toggleShow = _b[1];
    return (React.createElement("div", { id: "search" },
        React.createElement(Collapse, { className: "search-area", in: show },
            React.createElement("div", { className: "search-container" },
                React.createElement(Row, { className: "my-2" },
                    React.createElement(SearchDataList, { id: "parent-cd", name: "parent_cd", label: "NO\u30B3\u30FC\u30C9", value: search_params.parent_cd, sources: search_option, onChange: handleChangeSearchParams })),
                React.createElement(Row, { className: "my-2" },
                    React.createElement(SearchInput, { id: "no-cd", name: "no_cd", label: "\u8CA9\u58F2\u5E97\u30B3\u30FC\u30C9", value: search_params.no_cd, onChange: handleChangeSearchParams })),
                React.createElement("div", { className: "row my-3" },
                    React.createElement("div", { className: "col-md-12 col-sm-10 text-left" },
                        React.createElement("div", { className: "sarch-header" },
                            React.createElement("button", { className: "btn btn-main-color form-btn-size", disabled: false, onClick: function () { return handleClickSearch(); } }, "\u691C\u7D22"),
                            React.createElement("button", { className: "btn btn-bottom btn-main-color form-btn-size", disabled: false, onClick: handleClickCreateButton }, "\u767B\u9332"))))))));
};
export default NoStoreSearchForm;
